import Highcharts from 'highcharts';

export const getLdmRingOptions = (ldmPercent: number, weightPercent: number) => {
  return {
    chart: {
      type: 'solidgauge',
      height: 200,
    },
    title: null,
    credits: {
      enabled: false,
    },
    pane: {
      startAngle: 0,
      endAngle: 360,
      background: [
        {
          outerRadius: '100%',
          innerRadius: '75%',
          backgroundColor: new Highcharts.Color('#00e272').setOpacity(0.3).get(),
          borderWidth: 0,
        },
        {
          outerRadius: '75%',
          innerRadius: '50%',
          backgroundColor: new Highcharts.Color('#2caffe').setOpacity(0.3).get(),
          borderWidth: 0,
        },
      ],
    },
    yAxis: {
      min: 0,
      max: 100,
      lineWidth: 0,
      tickPositions: [],
    },
    tooltip: {
      enabled: false,
    },
    plotOptions: {
      solidgauge: {
        dataLabels: {
          enabled: false,
        },
        linecap: 'round',
        stickyTracking: false,
        rounded: false,
        borderRadius: 50,
      },
    },
    series: [
      {
        name: 'LDM',
        data: [
          {
            color: '#00e272',
            outerRadius: '100%',
            innerRadius: '75%',
            y: ldmPercent,
          },
        ],
      },
      {
        name: 'Weight',
        data: [
          {
            color: '#2caffe',
            radius: '75%',
            innerRadius: '50%',
            y: weightPercent,
          },
        ],
      },
    ],
  };
};

export const calculatePercent = (value: number, goal: number) => {
  return Math.min(goal ? (value / goal) * 100 : 0, 100);
};
